export enum AccessDeniedStrategy {
  hide = "hide",
  disable = "disable",
  redirect = "redirect",
  renderStub = "renderStub"
}
